module.exports = __webpack_public_path__ + "static/media/433971135_1082495509739093_8076718448997942633_n.5e631b0b.jpg";